var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFhPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7182 25.857C19.7812 25.857 16.8443 25.857 13.9074 25.857C12.6947 25.857 12.1073 25.214 12.1357 23.9181C12.221 19.3671 15.5843 15.2882 19.8476 14.7357C22.0171 14.4544 24.2245 14.374 26.3846 14.8763C30.1837 15.7604 33.0543 19.357 33.3195 23.476C33.329 23.6368 33.348 23.7975 33.348 23.9683C33.3953 25.1437 32.7701 25.847 31.6616 25.847C29.8236 25.847 27.9952 25.847 26.1572 25.847C25.0203 25.857 23.8645 25.857 22.7182 25.857Z",
    fill: "#135478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.086 12.9924C5.72274 12.9824 3.02266 10.089 3.0416 6.4924C3.05108 2.98622 5.82695 0.102908 9.15231 0.133047C12.4493 0.163186 15.1588 3.03645 15.1683 6.52254C15.1778 10.099 12.4493 13.0024 9.086 12.9924Z",
    fill: "#135478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7281 12.9924C19.3648 12.9824 16.6647 10.089 16.6837 6.4924C16.6932 2.98622 19.4596 0.102908 22.7944 0.133047C26.1008 0.153139 28.8388 3.07663 28.8104 6.56272C28.7914 10.1392 26.0819 13.0024 22.7281 12.9924Z",
    fill: "#135478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6198 15.2078C11.3219 16.6143 10.3366 18.2317 9.75865 20.1104C9.18074 21.979 8.85862 23.8778 9.3418 25.867C9.20916 25.867 9.086 25.867 8.97231 25.867C6.56592 25.867 4.16901 25.867 1.76262 25.867C0.597323 25.867 0.00993722 25.2341 0.000463255 23.9783C-0.0279586 20.5625 1.25103 17.8801 3.95111 15.9914C5.17325 15.1375 6.5375 14.6954 7.99649 14.6251C9.43654 14.5548 10.8861 14.5246 12.2882 15.027C12.3735 15.0571 12.4682 15.0872 12.5535 15.1274C12.5724 15.1274 12.5819 15.1576 12.6198 15.2078Z",
    fill: "#135478"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFhPeople);
export default __webpack_public_path__ + "static/media/ic_fh_people.551e74bdd9671631a0f13f8a950094d1.svg";
export { ForwardRef as ReactComponent };